function triggerSearch() {
  const $search = $('.js-search-article');
  const $searchInput = $search.find('.search-input');
  const searchTitle = $('.blog-page .module-title');
  const pagination = $('.pagination');

  if ($search.length > 0) {
    $searchInput.on('keyup', function() {
      const inputValue = $searchInput.val();
      if (inputValue) {
        $search.addClass('is-typing');
      } else {
        $search.removeClass('is-typing');
      }
    });
  }

  if ($('.blog').length > 0) {
    const resultString = $('.blog-page .module-title h4').html();
    const noResult = '0';
    const checkResult = resultString.match(noResult);

    if (checkResult) {
      $(searchTitle).addClass('hide');
    } else {
      $(searchTitle).removeClass('hide');
    }
  }

  if ($('.pagination .column').children().length === 0) {
    $(pagination).addClass('hide');
  } else {
    $(pagination).removeClass('hide');
  }
}

export default { triggerSearch };



// WEBPACK FOOTER //
// ./src/js/custom/search.js